export default "__VITE_ASSET__B3FZHpV6__"